<template>
  <div id="loadnnn">
    <el-row>
      <el-col :span="24" style="line-height: 48px;border-bottom: 1px solid #fff;">
		<el-form class="form" ref="form" :model="form" label-width="85px">
			<el-form-item label="日期：" class="form-item form-item-detail">
				<el-date-picker v-model="form.value1" type="date" placeholder="选择日期">
				</el-date-picker>
			</el-form-item>
			<el-form-item class="form-item">
				<el-button type="primary" size="mini" @click="onSubmit">查询</el-button>
			</el-form-item>
		</el-form>
      </el-col>
    </el-row>
    <el-row>
      <div class="xyfagl_one">
        <el-col :sm="24" :lg="12">
          <div class="xyfagl_one_left">
            <p>当日响应完成情况</p>
          </div>
          <div class="xyfagl_one_left_left">
            <span>响 应 方 案：</span><span>2020-07-15响应方案</span>
            <span>响 应 策 略：夏季空调控制策略</span>
            <span>响 应 目 标：2000kw</span>
            <span>实际响应负荷：1800kw</span>
            <span>响应起止时间：10：00-18：30</span>
            <span>奖 励 金 额：0</span>
          </div>
          <div id="pie2" style="height: 260px;width: 56%;float: left;"></div>
          <div class="clear"></div>
        </el-col>
        <el-col :sm="24" :lg="12">
          <div style="display: flex;flex-direction: column;color: #fff;text-align: left;">
            <div v-for="(item,index) in progressList" :key="index" style="margin: 10px;">
              <span>{{item.label}}</span>
              <br>
              <el-progress :text-inside="true" :stroke-width="20" :percentage="item.percentage" :color="item.color">
              </el-progress>
            </div>
          </div>
        </el-col>
      </div>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="echarts_two">
          <div id="pie1" style="width: 100%;height: 340px;"></div>
        </div>
      </el-col>
    </el-row>
    <el-row class="fhxyfx_table">
      <el-col :span="24" class="data-title">
        <p style="color: #fff;">数据列表</p>
        <p style="position: absolute;right: 10%;top: -1%;">
          <el-button type="primary" size="mini" @click="onSubmit">
            导出
          </el-button>
        </p>
      </el-col>
      <el-col :span="24">
        <el-table :data="tableData" border style="background-color: transparent !important;height: 400px;">
          <el-table-column prop="date" label="日期"></el-table-column>
          <el-table-column prop="UserName" label="方案名称"></el-table-column>
          <el-table-column prop="DeviceName" label="设备名称"></el-table-column>
          <el-table-column prop="date" label="响应起止时间"></el-table-column>
          <el-table-column prop="code" label="响应目标"></el-table-column>
          <el-table-column prop="name" label="实际响应"></el-table-column>
          <el-table-column prop="fff" label="完成度"></el-table-column>
          <el-table-column prop="address" label="奖励"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import * as echarts from '../../../public/static/echart/echarts';
  export default {
    data() {
      return {
        form: {
          value1: '',
        },
        pieChart1: null,
        pieChart2: null,
        pieChart3: null,
        progressList: [{
            label: '2020-7-10',
            color: "#50cb8c",
            percentage: 77
          },
          {
            label: '2020-7-11',
            color: "#858ba3",
            percentage: 27
          },
          {
            label: '2020-7-12',
            color: "#f77575",
            percentage: 67
          },
          {
            label: '2020-7-13',
            color: "#d27ac4",
            percentage: 47
          },
          {
            label: '2020-7-14',
            color: "#f0ae34",
            percentage: 87
          },
        ],
        tableData: [{
          date: '2016-05-02',
          UserName: '王小虎',
          DeviceName: '配电房',
          address: '0'
        }, {
          date: '2016-05-04',
          UserName: '王小虎',
          DeviceName: '配电房',
          address: '0'
        }, {
          date: '2016-05-01',
          UserName: '王小虎',
          DeviceName: '配电房',
          address: '0'
        }, {
          date: '2016-05-03',
          UserName: '王小虎',
          DeviceName: '配电房',
          address: '0'
        }],

      }
    },
    methods: {
      onSubmit() {},
      initChart() {
		var _this = this;
        this.pieChart1 = echarts.init(document.getElementById('pie1'));
        this.pieChart2 = echarts.init(document.getElementById('pie2'));
        var option = {
          title: {
            text: '实时负荷响应',
            textStyle: {
              color: "#fff"
            }
          },
          grid: {
            left: '5%',
            right: '4%',
            bottom: '10%',
            top: '15%',
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['基线负荷', '实际负荷'],
            textStyle: {
              color: "#fff"
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['0时', '1时', '2时', '3时', '4时', '5时', '6时', '7时', '8时', '9时', '10时', '11时', '12时', '13时',
              '14时', '15时', '16时', '17时', '18时', '19时', '20时', '21时', '22时', '23时'
            ],
            axisLine: {
              lineStyle: {
                color: "#fff",
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              formatter: '{value} kw'
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              }
            }
          },
          series: [{
              name: '基线负荷',
              type: 'line',
              data: [11, 11, 15, 13, 12, 13, 10, 11, 11, 15, 13, 12, 13, 10, 11, 11, 15, 13, 12, 13, 10, 5, 3],
              markPoint: {
                data: [{
                    type: 'max',
                    name: '最大值'
                  },
                  {
                    type: 'min',
                    name: '最小值'
                  }
                ]
              },
              //   markLine: {
              //     data: [{
              //       type: 'average',
              //       name: '平均值'
              //     }]
              //   }
            },
            {
              name: '实际负荷',
              type: 'line',
              data: [15, 13, 12, 13, 10, 11, 15, 13, 12, 13, 10, 11, 15, 13, 12, 13, 10, 11, 18, 20, 15, 2, 1, ],
              itemStyle: {
                normal: {
                  color: '#3995ff', //改变折线点的颜色
                  lineStyle: {
                    color: '#3995ff' //改变折线颜色
                  }
                }
              },
            }
          ]
        };
        var option2 = {
          title: {
            text: '负荷完成度',
            textStyle: {
              color: "#fff"
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 'right',
            data: ['完成', '未完成'],
            textStyle: {
              color: "#fff"
            }
          },
          series: [{
            name: '负荷完成度',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: [{
                value: 64,
                name: '完成',
                itemStyle: {
                  normal: {
                    color: '#5dd768', //改变折线点的颜色
                    lineStyle: {
                      color: '#5dd768' //改变折线颜色
                    }
                  }
                },
              },
              {
                value: 36,
                name: '未完成',
                itemStyle: {
                  normal: {
                    color: '#ff7575', //改变折线点的颜色
                    lineStyle: {
                      color: '#ff7575' //改变折线颜色
                    }
                  }
                },
              },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              },
            }
          }]
        }
        this.pieChart1.setOption(option, true);
        this.pieChart2.setOption(option2, true);
		window.addEventListener("resize", function(){
		  _this.pieChart1.resize();
		  _this.pieChart2.resize();
		});
      },
    },
    mounted() {
      this.initChart();
    }
  }

</script>
<style scoped>
  .xyfagl_one {
	height: 299px;
	padding: 10px 40px;
    box-sizing: border-box;
  }

  .xyfagl_one_left {
    padding-left: 10px;
  }

  .xyfagl_one_left p {
    color: #fff;
    font-size: 19px;
    text-align: center;
	margin: 10px;
    line-height: 20px;
    font-weight: bold;
  }

  .xyfagl_one_left_left {
    float: left;
    width: 40%;
    display: flex;
    flex-direction: column;
    color: #fff;
    text-align: left;
    padding-left: 20px;
  }

  .xyfagl_one_left_left span {
    margin: 5px;
  }
  .clear {
    clear: both;
  }

  .echarts_two {
    height: 350px;
    width: 100%;
	border-top: 1px solid #56659a;
	padding: 10px 40px;
    box-sizing: border-box;
  }

  .fhxyfx_table {
    width: 100%;
    border-top: 1px solid #fff;
  }
</style>
